import React, { useCallback, useMemo, useReducer } from 'react';

import verificationConstants    from './verification.constants';
import VerificationContext      from './verification.context';
import verificationReducer      from './verification.reducer';
import verificationInitialState from './verification.state';

import useRequest from '../../common/services/request';

/**
 * @type {React.FC}
 */

function VerificationProvider({
  children,
  value,
}) {
  const [state, dispatch] = useReducer(verificationReducer, {
    ...verificationInitialState,
    order:              value.order || verificationInitialState.order,
    initialStateLoaded: !!value.order,
  });
  const { post }          = useRequest();

  const orderVerification = useCallback((code) => {
    dispatch({ type: verificationConstants.VERIFICATION_GET_DATA_REQUEST });

    const url = `api/verify`;

    return post(url, { code })
      .then((response) => dispatch({ type: verificationConstants.VERIFICATION_GET_DATA_SUCCESS, ...response }))
      .catch((error) => dispatch({ type: verificationConstants.VERIFICATION_GET_DATA_FAILURE, ...error }));
  }, [dispatch]);

  const context = useMemo(() => ({
    ...state,
    orderVerification,
  }), [orderVerification, state]);

  return (
    <VerificationContext.Provider value={context}>
      {children}
    </VerificationContext.Provider>
  );
}

export default VerificationProvider;